import React from 'react';

interface IOptionProps {
	allProps: any;
	option: any;
}

const OptionItem = (props: IOptionProps) => {
	
	console.log("props.option: ", props.option);
	
	return (
		<li {...props.allProps} className="autocomplete__option" key={props.option.image}>
			{
				props.option.type === "takeOut" ? (
					<div className="autocomplete__option_takeOut">
						<div className="autocomplete__option_takeOut_img">
							{props.option.image && (
								<img
									src={props.option.image}
									alt={props.option.label}
								/>
							)}
						</div>
						<div className="autocomplete__option_takeOut_data">
							<div className="autocomplete__option_takeOut_data_info">
								<span>{props.option.label}</span>
								<p>{props.option.description}</p>
							</div>
							<div className="autocomplete__option_takeOut_data_add">
								<div className="autocomplete__option_takeOut_data_add_price">
									<span>€{props.option.priceBefore}</span>
									<p>€{props.option.priceNow}</p>
								</div>
								<div className="autocomplete__option_takeOut_data_add_type">
									<span>Take-out</span>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="autocomplete__option_takeOut">
						<div className="autocomplete__option_takeOut_img">
							{props.option.image && (
								<img
									src={props.option.image}
									alt={props.option.label}
								/>
							)}
						</div>
						<div className="autocomplete__option_takeOut_data">
							<div className="autocomplete__option_takeOut_data_info">
								<span>{props.option.label}</span>
							</div>
							<div className="autocomplete__option_takeOut_data_add">
								<div className="autocomplete__option_takeOut_data_add_price">
									<p>-{props.option.discount}%</p>
								</div>
								<div className="autocomplete__option_takeOut_data_add_type">
									<span>Dine-in</span>
								</div>
							</div>
						</div>
					</div>
				)
			}
			
			{/* <span>{props.option.label}</span>
			<div className="option-content">
				{props.option.image && (
					<img
						src={props.option.image}
						alt={props.option.label}
						className="option-image"
					/>
				)}
				<div className="option-text">
					<div className="option-label">{props.option.label}</div>
					{props.option.type === "restaurant" && props.option.address && (
						<div className="option-address">{props.option.address}</div>
					)}
				</div>
			</div> */}
		</li>
	);
};

export default OptionItem;